<template>
  <div class="sidecart_empty">
    <div v-html="messageOutput"></div>

    <ul class="sidecart_empty_buttons">
      <li v-for="(block, i) in buttonBlocks" :key="i" v-html="blockToOutput(block)"></li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'cart_empty',
    props: ['blocks'],
    computed: {
      messageOutput: function() {
        const messageBlock = (this.blocks || []).find(block => block && block.type === 'message');
        return messageBlock ? this.blockToOutput(messageBlock) : '';
      },
      buttonBlocks: function() {
        return (this.blocks || []).filter(block => block && block.type === 'button_link');
      },
    },
    methods: {
      blockToOutput: function(block) {
        const { type, ...settings } = block;
        switch (type) {
          case 'button_link':
            return `<a href="${ settings.link }" class="button _secondary _strong">${ settings.title }</a>`;
            break;
          case 'message':
            return `<div class="sidecart_empty_text">${ settings.text }</div>`;
            break;
          default:
            return '';
        }
      },
    },
  }
</script>
